<template>
  <div
    class="auth-page w-100 position-absolute bg-auth text-center login-welcome"
    :style="{ backgroundImage: bgImage }"
  >
    <b-container fluid>
      <b-row align-h="center" class="h-100 no-gutters pt-2 pt-md-5 text-center">
        <b-col cols="12" sm="12" md="6" lg="6" class="p-4">
          <div class="wrapper ">
            <b-container>
              <b-row class="py-4">
                <b-col>
                  <router-link to="/">
                    <img
                      :src="logo"
                      height="35"
                      class="mt-4"
                      alt="RealVest Logo"
                    />
                  </router-link>
                </b-col>
              </b-row>
            </b-container>

            <div class="email-verification-wrapper p-4 mx-auto bg-auth-white">
              <div class="heading-wrapper pt-1 pb-1 text-center">
                <h4 class="heading font-weight-bold text-black-50">
                  Email Verification
                </h4>
                <b-spinner v-if="loading"></b-spinner>
                <div v-else-if="error">
                  <i class="fas fa-times-circle fa-3x text-danger my-3"></i>
                  <p>{{ errorMsg }}</p>
                  <router-link
                    to="/login"
                    style="text-decoration:underline !important"
                    >Login</router-link
                  >
                </div>
                <div v-else>
                  <i class="fas fa-check-circle fa-3x text-success my-3"></i>
                  <p>Your email has been successfully verified</p>
                  <router-link to="/login" class="btn btn-secondary"
                    >Login</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { AuthService } from "@/services";

export default {
  name: "verify-email",
  data() {
    return {
      logo: require("@/assets/icons/logo-dark.svg"),
      bgImage: `url(${require("@/assets/images/realvest1.jpg")})`,

      error: false,
      errorMsg: "",
      loading: true
    };
  },
  methods: {
    ...mapActions("auth", ["logout"])
  },
  async created() {
    await this.logout({ reRoute: false });
    const { token } = this.$route.params;
    try {
      await AuthService.verifyEmail(token);
    } catch (err) {
      this.error = true;
      this.errorMsg = err.message;
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.email-verification-wrapper {
  height: fit-content;
  overflow: hidden;
  border-radius: 4px;
  max-width: 500px;
}

.login-welcome {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background-color: var(--secondary);
    opacity: 0.6;
    width: 100%;
    height: 100%;
  }
}
</style>
